import { useState } from "react";
import styles from "./HeaderDropdown.module.css";
import MindPageLink from "../MindPageLink/MindPageLink";

function HeaderDropdown({
    text,
    data,
    className,
    id,
    style,
    bufferContainerStyle,
    width,
    linkMode = false,
}) {
    const [showDropdown, setShowDropdown] = useState(false);

    function handleMouseEnter() {
        setShowDropdown(true);
    }

    function handleMouseLeave() {
        setShowDropdown(false);
    }

    return (
        <div
            className={[
                styles.header_dropdown_container,
                showDropdown ? styles.show : undefined,
            ].join(" ")}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{ width }}
        >
            <button
                className={[
                    linkMode ? styles.link_dropdown : styles.header_dropdown,
                    className,
                ].join(" ")}
                id={id}
                style={style}
            >
                {text}
                {!linkMode && (
                    <svg
                        className={styles.arrow}
                        width="28"
                        height="16"
                        viewBox="0 0 28 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2 2L14 14L26 2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                )}
            </button>
            <div
                className={styles.children_container_buffer}
                style={bufferContainerStyle}
            >
                <div className={styles.children_container}>
                    {data.map(({ href, name, ...props }) => (
                        <MindPageLink
                            className={styles.navlink}
                            href={href}
                            {...props}
                            key={href}
                        >
                            {name}
                        </MindPageLink>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default HeaderDropdown;
